import {
	Text,
	View,
	StyleSheet,
	Pressable,
	FlatList,
	Image,
} from "react-native";
import { discounts_4schools_image_path } from "../store/api";

const pizzaLogo = require("../../assets/images/pizzaHut_logo.png");
const mcDonaldLogo = require("../../assets/images/mcDonald_logo.png");
const paoLogo = require("../../assets/images/pao_logo.png");
const oggiLogo = require("../../assets/images/oggi_logo.png");

const FoodDiscountsRail = ({
	foodDiscounts,
	navigation,
	setSelectedFilters,
}) => {
	return (
		<View style={styles.container}>
			<View style={styles.header}>
				<Text style={styles.headerTitle}>Alimentação</Text>
				<Pressable
					onPress={() =>
						setSelectedFilters(currentValue => ({
							...currentValue,
							category: "Alimentação",
						}))
					}
				>
					<Text style={styles.headerReadMore}>Ver mais</Text>
				</Pressable>
			</View>
			<View>
				<FlatList
					horizontal
					data={foodDiscounts}
					ListFooterComponent={() => <View></View>}
					renderItem={({ item, index }) => (
						<Pressable
							key={item.id}
							onPress={() => {
								navigation.navigate("SpecificDiscount", { info: item });
							}}
							style={[
								styles.item,
								{
									marginLeft: index === 0 ? 24 : 0,
								},
							]}
						>
							{item.logo_image_id && (
								<Image
									source={{
										uri: discounts_4schools_image_path + item.logo_image_id,
									}}
									style={styles.image}
								/>
							)}
							<Text
								style={{
									color: item.title_color,
									fontSize: 12,
									lineHeight: 16,
									marginTop: 20,
									fontFamily: "DmSans-bold",
								}}
							>
								{item.company_name}
							</Text>
							<Text
								style={{
									color: "#000",
									marginTop: 12,
									fontSize: 16,
									lineHeight: 16,
									fontFamily: "DmSans",
								}}
							>
								{item.title}
							</Text>
						</Pressable>
					)}
				/>
			</View>
		</View>
	);
};

export default FoodDiscountsRail;

const styles = StyleSheet.create({
	container: {
		marginBottom: 20,
	},
	header: {
		flexDirection: "row",
		marginBottom: 12,
		paddingHorizontal: 24,
		justifyContent: "space-between",
	},
	headerTitle: {
		fontSize: 18,
		lineHeight: 26,
		color: "#3C351F",
		fontFamily: "DmSans-bold",
	},
	headerReadMore: {
		fontFamily: "DmSans-bold",
		fontSize: 14,
		color: "#0843F5",
		marginTop: 3,
	},
	item: {
		width: 143,
		height: 200,
		marginRight: 15,
		overflow: "hidden",
		borderRadius: 20,
		backgroundColor: "#fff",
		paddingTop: 20,
		paddingHorizontal: 15,
	},
	image: { height: 60, resizeMode: "contain" },
});
